export const calculateClassName = (
  index: number,
  className: string,
): string => {
  if (!(index === 1)) return "";

  return className;
};
